import { createFileRoute } from '@tanstack/react-router';

import { BloodReportPreviewPage } from '@/pages/blood-report';

export const Route = createFileRoute('/blood-report/_role-guard/$id/_report/preview')({
  component: BloodReportPreviewPage,
});
